var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-layout",
    {
      attrs: { title: _vm.PRODUCT_NAME2 },
      on: { open: _vm.onOpen },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("Header", {
                attrs: { title: _vm.PRODUCT_NAME2, readonly: true }
              })
            ]
          },
          proxy: true
        },
        {
          key: "sidebar",
          fn: function() {
            return [
              _c(
                "div",
                [
                  _c("TotalePreventivo", { staticClass: "mb-3" }),
                  _vm._v(" "),
                  _c("Itinerario", {
                    attrs: { href: "itinerarioRef" },
                    on: { service: _vm.onDetailService }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return [
              _vm.isMobile
                ? _c(
                    "div",
                    {
                      staticClass: "menu-footer d-flex justify-content-between"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-select",
                          on: {
                            click: function($event) {
                              return _vm.onSelectMenu(1)
                            }
                          }
                        },
                        [
                          _c("h5", [
                            _vm._v("Totale: " + _vm._s(_vm.totale) + " €")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "custom-select",
                          on: {
                            click: function($event) {
                              return _vm.onSelectMenu(2)
                            }
                          }
                        },
                        [_c("h5", [_vm._v("Itinerario")])]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.open
                ? _c("div", { staticClass: "bottom-menu-popup border-top" }, [
                    _c("div", [
                      _c("div", { staticClass: "d-flex justify-content-end" }, [
                        _c("div", { staticClass: "close" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/svg/blue/icone_close.svg"),
                              height: "24px"
                            },
                            on: {
                              click: function($event) {
                                _vm.open = false
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "content-area",
                          staticStyle: {
                            "max-height": "100%",
                            overflow: "auto"
                          }
                        },
                        [
                          _vm.selected === 1
                            ? _c("TotalePreventivo", { staticClass: "mb-3" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selected === 2
                            ? _c("Itinerario", {
                                on: { service: _vm.onDetailService }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [_vm._v(" "), [_c("WizzardTour", { ref: "wizardRef" })]],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05af2acd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05af2acd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/Tour.vue
// module id = null
// module chunks = 